/* 
Object:         Image
Description:    Logic and events for the module Image
Used in:        Image
*/

import { ModuleActionViewEnum } from "../enums/moduleActionViewEnum";

import * as appsettings from "../appsettings";
import * as dialog      from "../dialog";
import * as main        from "../main";    
import * as navigation  from "../navigation";
import * as viewmode    from "../viewmode";

export function showItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    // Set mode 
    viewmode.setViewMode(ModuleActionViewEnum.Show);

    // select the item
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as EditVM;

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("Img/Edit?imgId=" + dataItem.ImgID + "&breadcrumbLabel=" + dataItem.Label);
}

export function editItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    // Set mode 
    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    // select the item
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as EditVM;

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("Img/Edit?imgId=" + dataItem.ImgID + "&breadcrumbLabel=" + dataItem.Label);
}

export function deleteItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    const event = e;
    const data = this;

    // Prevent default behaviour 
    event.preventDefault();

    function callbackYes(event: JQuery.Event & { currentTarget: HTMLElement }, data: kendo.ui.Grid): void {

        const dataItem = data.dataItem($(event.currentTarget).closest("tr")) as EditVM;

        // Post Data
        $.ajax({
            type: "GET",
            url: appsettings.getUrl("Img/Delete?imgId=" + dataItem.ImgID),
            success: function (responseData: responseModel | undefined | null) {

                // Refresh datasource grid 
                $("#imgGrid").data("kendoGrid").dataSource.read();

                // Do callbackJS 
                if (responseData.CallbackJS != null && responseData.CallbackJS != undefined) {
                    Function(responseData.CallbackJS)();
                    // execute callbackJS content (dont wrap more than one function call in one function as a wrapper, that will not execute)
                }

                // Show error if any
                if (responseData.Succesfully == false) {
                    main.openActionsDialog(' ',
                        responseData.Message, [{
                            text: 'Ok',
                            action: function () {
                                main.closePopup();
                            }, primary: true
                        }]);
                }
            }
        });
    }

    function callingCallback() {
        callbackYes(event, data);
    }

    dialog.createDialog(callingCallback, function () { });

}
